import React from 'react';
import Header from './Header';
import Navigation from './Navigation';
import DonationCTA from './DonationCTA';
import DonorsFloatingBtn from './DonorsFloatingBtn';

const Layout = ({ children, currentPage, onNavigate, isMenuOpen, setIsMenuOpen }) => {
  return (
    <div className="app-layout">
      <Header
        onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        onHomeClick={() => onNavigate('home')}
      />

      <main className="main-content-area">
        <Navigation
          currentPage={currentPage}
          onNavigate={onNavigate}
        />
        <div className="page-wrapper">
          {children}
        </div>
        
        <div className="floating-actions-container">
          <DonorsFloatingBtn onNavigate={onNavigate} />
          <DonationCTA />
        </div>
      </main>

      <footer className="temple-footer">
        <p className="footer-copyright">© {new Date().getFullYear()} శ్రీ సీతారామచంద్రస్వామి వారి దేవస్థానం, వామకుంట్ల.</p>
      </footer>

      {/* Side Drawer Overlay */}
      <div className={`side-drawer ${isMenuOpen ? 'open' : ''}`}>

        <div className="drawer-header">
          <button className="close-drawer" onClick={() => setIsMenuOpen(false)}>✕</button>
          <img src="/nama-hg-rb.png" alt="Nama" className="drawer-logo" />
        </div>
        <ul className="drawer-links">
          <li onClick={() => onNavigate('home')}>హోమ్</li>
          <li onClick={() => onNavigate('charitra')}>చరిత్ర</li>
          <li onClick={() => onNavigate('media')}>సంగీత కీర్తనలు</li>
        </ul>
      </div>
      <div 
        className={`drawer-backdrop ${isMenuOpen ? 'active' : ''}`} 
        onClick={() => setIsMenuOpen(false)}
      ></div>
    </div>
  );
};

export default Layout;
